import { Ref, computed } from '@vue/composition-api';
import {
  AdType,
  AD_TYPE,
  BC_IDENTITY_TYPES_LIST,
  FullNormalFormData,
  IdentityInfo,
  IDENTITY_TYPE_MAP,
} from '@tt4b/ttam-enums';
import { i18n } from '@tt4b/ttam-i18n';
import { logger } from '@tt4b/ttam-utils';

/** 素材选择标题 */
export function usePropsTitle(options: {
  isNativePullPost: Ref<boolean>;
  currentAdType: Ref<AdType>;
  isSmartCreative: Ref<boolean>;
}) {
  const { isNativePullPost, currentAdType, isSmartCreative } = options;

  const title = computed(() => {
    if (isNativePullPost.value) {
      return i18n.t('module_native_ad_video_specification_tip');
    }

    const materialTitleMap = {
      [AD_TYPE.SINGLE_IMAGE.value]: i18n.t('procedural-material-type-image'),
      [AD_TYPE.SINGLE_VIDEO.value]: i18n.t('procedural-material-type-video'),
      [AD_TYPE.CAROUSEL_IMAGE.value]: i18n.t('procedural-material-type-carousel'),
      [AD_TYPE.CATALOGUE_VIDEO.value]: i18n.t('procedural-material-type-video'),
    };

    return materialTitleMap[currentAdType.value];
  });

  return {
    title,
  };
}

export function usePropsIsHasPushVideoAuthority(options: {
  creativeData: Ref<FullNormalFormData>;
  identityBind: Ref<Partial<IdentityInfo>>;
}) {
  const { creativeData, identityBind } = options;

  const isHasPushVideoAuthority = computed(() => {
    const { identityId, identityType, identityData } = creativeData.value;

    if (identityType !== IDENTITY_TYPE_MAP.TT_USER) {
      return false;
    }

    if (identityId === identityBind.value?.identityId) {
      return identityBind.value?.canManageVideo;
    }

    return Boolean(identityData?.canManageVideo);
  });

  return {
    isHasPushVideoAuthority,
  };
}

export function usePropsMaterialSelectControl(options: {
  isShop: Ref<boolean>;
  isLive: Ref<boolean>;
  isSmartOn: Ref<boolean>;
  isCatalogVideo: Ref<boolean>;
  isIdentityHasPushVideoRight: Ref<boolean>;
  creativeData: Ref<FullNormalFormData>;
}) {
  const { isShop, isLive, isSmartOn, isCatalogVideo, isIdentityHasPushVideoRight, creativeData } = options;

  /** 是否禁用原生拉视频按钮 */
  const isPostButtonDisabled = computed(() => {
    const shouldHasBcId = BC_IDENTITY_TYPES_LIST.includes(creativeData.value?.identityType || 0);
    const isValidBcId = !shouldHasBcId || (shouldHasBcId && creativeData.value?.identityBcId);
    return !creativeData.value?.identityId || !isValidBcId;
  });

  /** 推视频按钮是否禁用 */
  const isPushVideoButtonDisabled = computed(() => !isIdentityHasPushVideoRight.value);

  const isCatalogVideoSelectVisible = computed(
    () => !isShop.value && !isLive.value && (isSmartOn.value || isCatalogVideo.value),
  );

  return {
    isPostButtonDisabled,
    isCatalogVideoSelectVisible,
    isPushVideoButtonDisabled,
  };
}
